export enum ACTIONTYPES {
	back = 'back',
	close = 'close',
	skip = 'skip',
	none = 'null'
}

export const STEP_TYPES = {
	step: 'STEP',
	subStep: 'SUB_STEP',
	hybrid: 'HYBRID'
} as const;

export const FLOW_DIRECTION = {
	forward: 'NEXT',
	backward: 'BACK'
} as const;
